export default __webpack_public_path__ + "static/media/importantupdate.ac0e00b4.png";